import React from "react";
import Select from "react-select";
import { Field } from "formik";

export interface SelectOption {
  label: string;
  value: string;
}

export interface FormikMultiSelectProps {
  options: SelectOption[];
  name: string;
  value: string[];
}
export interface FormikMultiSelectState {
  selectedOptions: any;
}

export default class FormikMultiSelect extends React.Component<FormikMultiSelectProps, FormikMultiSelectState> {
  constructor(props: FormikMultiSelectProps) {
    super(props);
    console.log(props);
    this.state = {
      selectedOptions: null,
    };
    if (this.props.value) {
      // find the mapping labels and add to selected options
      this.state = {
        selectedOptions: this.props.options.filter((option: SelectOption) => {
          return this.props.value.includes(option.value);
        }),
      };
    }
    this.handleChange = this.handleChange.bind(this);
  }

  public handleChange(selectedOptions: SelectOption[], form: any) {
    this.setState({ selectedOptions }, () => console.log("Option selected:", this.state.selectedOptions));
    form.setFieldValue(
      this.props.name,
      selectedOptions
        ? selectedOptions.map((selectOption: SelectOption) => {
            return selectOption.value;
          })
        : [],
    );
  }

  public render() {
    const { selectedOptions } = this.state;

    return (
      <Field name={this.props.name}>
        {({ form }: { field: any; form: any }) => (
          <Select
            isMulti={true}
            value={selectedOptions}
            onChange={(opts) => {
              this.handleChange(opts as SelectOption[], form);
            }}
            options={this.props.options}
          />
        )}
      </Field>
    );
  }
}
